/**
 * Price lists API client (BFF: `/api/v1/catalog/pricing/price-lists`) — a local, minimal copy for
 * the Evotor Stores panel's "Price list" select (design spec §8.7). FSD forbids importing
 * another feature's `api/` module, so this mirrors `features/catalog/api/catalogPriceListsApi.ts`
 * (the same BFF resource, confirmed live 2026-09-03) rather than reaching across the feature
 * boundary — the precedent `features/inventory/api/locationsApi.ts` set for
 * `store-settings/api/storeServiceApi.ts`.
 */
import { apiClient } from '@/shared/api';

export interface PriceListOption {
  code: string;
  name: string;
  active: boolean;
}

export interface PriceListBinding {
  storeCode: string;
  priceListCode: string;
}

const BASE = '/api/v1/catalog/pricing/price-lists';

export const listPriceLists = async (): Promise<PriceListOption[]> =>
  (await apiClient.get<PriceListOption[]>(BASE)).data;

export const listPriceListBindings = async (code: string): Promise<PriceListBinding[]> =>
  (await apiClient.get<PriceListBinding[]>(`${BASE}/${encodeURIComponent(code)}/bindings`)).data;

/** Idempotent — re-binding a store already bound elsewhere MOVES the binding (never duplicates). */
export const bindPriceListStore = async (code: string, storeCode: string): Promise<PriceListBinding> =>
  (
    await apiClient.put<PriceListBinding>(
      `${BASE}/${encodeURIComponent(code)}/bindings/${encodeURIComponent(storeCode)}`,
    )
  ).data;

export const unbindPriceListStore = async (code: string, storeCode: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${encodeURIComponent(code)}/bindings/${encodeURIComponent(storeCode)}`);
};
